export default __webpack_public_path__ + "static/media/icon-radio-circle-marked.1dba098a.svg";